import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { ExecucaoOrcamentaria } from '../../models/execucao-orcamentaria.model';
import { AtualizacoesAuditService } from '../../services/atualizacoes-audit.service';
import { ExecucaoOrcamentariaService } from '../../services/execucao-orcamentaria.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';

@Component({
  selector: 'app-detalhe-projeto-execucao-orcamentaria-itens',
  templateUrl: './detalhe-projeto-execucao-orcamentaria-itens.component.html',
  styleUrls: ['./detalhe-projeto-execucao-orcamentaria-itens.component.scss']
})
export class DetalheProjetoExecucaoOrcamentariaItensComponent extends BaseFormComponent<ExecucaoOrcamentaria> implements OnInit, OnDestroy {

  @Input() idExecucao: number;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  list: any;
  permission: any;
  listAudit: AtualizacoesAudit[];

  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;

  constructor(
    private myService: ExecucaoOrcamentariaService,
    private auditService: AtualizacoesAuditService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.permission = this.activatedRoute.snapshot.data['permission'];
      this.listAudit = this.activatedRoute.snapshot.data['audit'];
      this.initForm();
      this.initList();
    });
    
    this.addSub(EventSharedService.get('reloadPermission').subscribe((permission) => {
      this.cleanForm();
      this.initList(permission);
    }))
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList(permission = false) {
    this.loading();
    this.addSub(
      this.myService.getItensList(this.idExecucao).subscribe({
        next: (res) => {
          this.list = res;
          this.list.forEach(item => {
            item?.list.forEach((value, index) => {
              if (value) {
                this.getFormArray(this.lowercase(item?.name_table)).push(this.createFormGroup(value, item.name_table));
                if (!value?.checked) {
                  this.disableFields(item?.name_table, index)
                }
              }
            })
          })
          if (permission) {
            this.permission = permission;
          }
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  disableFields(key, index){
    if(this.lowercase(key) != 'projeto'){
      const formGroup = this.getFormArray(this.lowercase(key)).controls[index] as FormGroup;
      Object.keys(formGroup.controls).forEach(key => {
        if (key !== 'checked' && key !== 'id' && key !== 'type') {
          formGroup.get(key)?.disable();
        }
      });
    }
  }

  initForm() {
    this.form = new FormGroup({
      projeto: new FormArray([]),
      indicador: new FormArray([]),
      entrega: new FormArray([]),
    });
  }

  cleanForm(){
    this.getFormArray('projeto').clear();
    this.getFormArray('indicador').clear();
    this.getFormArray('entrega').clear();
  }

  createFormGroup(values = null, key= ''): FormGroup {
    var manual = values?.manual;
    return new FormGroup({
      id: new FormControl(values?.id),
      type: new FormControl(key),
      checked: new FormControl(values?.checked),
      previsao: new FormControl(this.maskService.formatarMedidaFisica(manual?.previsao, 2)),
      dotacao_loa: new FormControl(this.maskService.formatarMedidaFisica(manual?.dotacao_loa,2)),
      empenhado: new FormControl(this.maskService.formatarMedidaFisica(manual?.empenhado,2)),
      liquidado: new FormControl(this.maskService.formatarMedidaFisica(manual?.liquidado,2)),
      pago: new FormControl(this.maskService.formatarMedidaFisica(manual?.pago,2)),
      liquidado_exercicio_anterior: new FormControl(this.maskService.formatarMedidaFisica(manual?.liquidado_exercicio_anterior,2)),
      pago_exercicio_anterior: new FormControl(this.maskService.formatarMedidaFisica(manual?.pago_exercicio_anterior,2)),
      observacoes: new FormControl(manual?.observacoes),
    });
  }

  getFormArray(field: string): FormArray {
    return this.form.get(field) as FormArray;
  }

  lowercase(name: string) {
    return name.toLocaleLowerCase();
  }

  habilitaForm(index: number, form: string, checked: boolean) {
    if(this.permission?.execucao_orcamentaria_manual){
      if (!checked) {
        this.disableFields(form, index);
      } else {
        this.getFormArray(form).controls[index].enable();
      }
      
    }
  }

  getDataCreate(): ExecucaoOrcamentaria {
    let data: ExecucaoOrcamentaria;
    const projetoArray = this.getFormArray('projeto').value;
    const indicadorArray = this.getFormArray('indicador').valid ? this.getFormArray('indicador').value : [];
    const entregaArray = this.getFormArray('entrega').valid ? this.getFormArray('entrega').value : [];
    const combinedArray = projetoArray.concat(indicadorArray, entregaArray);
    data = Object.assign({}, data, combinedArray);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.idExecucao) {
        this.addSub(
          this.myService.itensUpdate(this.getDataCreate(), this.idExecucao).subscribe({
            next: (res) => {
              
              EventSharedService.get('vinculo').emit(true);
              this.cleanForm()
              this.initList();
              this.auditRefresh();
              this.confirmation("Execução Orçamentaria alterada com sucesso!").subscribe(() => {
                window.location.reload();
              })
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  formatarMedidaFisica(index: number, field: string, form: string) {
    let valueField = this.getFormArray(form).controls[index].get(field)?.value;
    let value = this.maskService.formatarMedidaFisica(valueField, 2);
    this.getFormArray(form).controls[index].get(field).setValue(value);
  }

  viewResonsavel(item: any) {
    this.modalResonsavel.openModal([item, ...item?.resp_adj]);
  }

  auditRefresh(){
    let audit = {
      budget_id: this.idExecucao,
      budget_assoc_fpe_id: this.idExecucao,
    };

    this.addSub(
      this.auditService.getAtualizacoes(audit).subscribe((res)=>{
        this.listAudit = res;
        EventSharedService.get('auditRefresh').emit(res);
      })
    );
  }
}
